import qs from "qs";

import { axiosWithAuth } from "helpers";
import { mapChargebacksQueueDataToServer } from "mappers";
import { ChargebacksFetchDataParams } from "types";

export const chargebacksService = {
	claimMerchant,
	downloadAllMerchantCsvFile,
	downloadHistoricalCsvFile,
	downloadInReviewCsvFile,
	getAllMerchant,
	getHistorical,
	getInReview,
	unClaimMerchant,
};

const API_URL = process.env.REACT_APP_API_URL;

function getAllMerchant({ page, filters, sortBy }: ChargebacksFetchDataParams) {
	const body = mapChargebacksQueueDataToServer({
		page,
		filters,
		sortBy,
	});

	const options = {
		url: `${API_URL}/api/chargeback_reviews/all_merchants`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getInReview({ page, filters, sortBy }: ChargebacksFetchDataParams) {
	const body = mapChargebacksQueueDataToServer({
		page,
		filters,
		sortBy,
	});
	const options = {
		url: `${API_URL}/api/chargeback_reviews/in_review`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getHistorical({ page, filters, sortBy }: ChargebacksFetchDataParams) {
	const body = mapChargebacksQueueDataToServer({
		page,
		filters,
		sortBy,
	});
	const options = {
		url: `${API_URL}/api/chargeback_reviews/historical`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function claimMerchant({ id }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/chargeback_reviews/${id}/assign`,
	};

	return axiosWithAuth(options);
}

function unClaimMerchant({ id }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/chargeback_reviews/${id}/unassign`,
	};

	return axiosWithAuth(options);
}

function downloadAllMerchantCsvFile({
	page,
	filters,
	sortBy,
	token,
}: ChargebacksFetchDataParams) {
	const params = mapChargebacksQueueDataToServer({
		page,
		filters,
		sortBy,
	});

	const url = `${API_URL}/api/chargeback_reviews/all_merchants/csv?token=${token}&${qs.stringify(
		params,
		{ arrayFormat: "repeat" },
	)}`;
	let link = document.createElement("a");
	link.href = url;

	link.click();
}

function downloadInReviewCsvFile({
	page,
	filters,
	sortBy,
	token,
}: ChargebacksFetchDataParams) {
	const params = mapChargebacksQueueDataToServer({
		page,
		filters,
		sortBy,
	});

	const url = `${API_URL}/api/chargeback_reviews/in_review/csv?token=${token}&${qs.stringify(
		params,
		{ arrayFormat: "repeat" },
	)}`;
	let link = document.createElement("a");
	link.href = url;

	link.click();
}

function downloadHistoricalCsvFile({
	page,
	filters,
	sortBy,
	token,
}: ChargebacksFetchDataParams) {
	const params = mapChargebacksQueueDataToServer({
		page,
		filters,
		sortBy,
	});

	const url = `${API_URL}/api/chargeback_reviews/historical/csv?token=${token}&${qs.stringify(
		params,
		{ arrayFormat: "repeat" },
	)}`;
	let link = document.createElement("a");
	link.href = url;

	link.click();
}
